import { InjectionToken, Type } from '@angular/core';
import { NgxLoggerLevel } from 'ngx-logger';

/**
 * Injection token for shared-services environment.
 */
export const SERVICES_ENV = new InjectionToken('SERVICES_ENV');

export interface SharedServicesEnvironment {
  telemetryServerUrl: string;
  consoleTelemetryLevel: NgxLoggerLevel;
  serverTelemetryLevel: NgxLoggerLevel;
}

export type SharedServicesEnvironmentType<T extends SharedServicesEnvironment> = Type<T>;

export interface SharedServicesEnvironmentConfig<T extends SharedServicesEnvironment> {
  sharedServicesEnvironmentType: SharedServicesEnvironmentType<T>;
}
